import script from "./PlatMapModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatMapModal.vue?vue&type=script&setup=true&lang=ts"

import "./PlatMapModal.vue?vue&type=style&index=0&id=210268f7&lang=scss"

const __exports__ = script;

export default __exports__